module.exports = __webpack_public_path__ + "img/logo-company.7c2bff84.png";